/**
 * Späte Ergebnisse (Foto-Upload an einer Mängelkarte, Assistent nach dem
 * Notausgang) an die Prüfmodul-Instanz, die GERADE für dieses Projekt steht.
 *
 * Eine Instanz, die ausgehängt wurde, während ihr Upload lief, darf nicht
 * selbst schreiben: ihr Stand ist eingefroren. Kehrt der Prüfer inzwischen ins
 * Modul zurück, hält die neue Instanz eine eigene Kopie des Berichts — eine
 * Änderung nur am App-Bericht sähe sie nicht und überschriebe sie mit der
 * nächsten Eingabe. Deshalb meldet sich jede eingehängte Instanz hier an, und
 * die alte gibt ihr Ergebnis an sie weiter. Ohne eingehängte Instanz übernimmt
 * App.tsx (onSpaetAendern).
 *
 * Muster wie registriereVerlassenWache und registriereZurueck: eine Anmeldung,
 * die beim Abbau genau sich selbst wieder abmeldet.
 */
import type { Report } from '../types';

export type SpaetAenderung = (report: Report) => Report;
type Empfaenger = (aendern: SpaetAenderung) => void;

const empfaenger = new Map<string, Empfaenger>();

/** Meldet die eingehängte Instanz eines Projekts an; die Rückgabe meldet genau sie wieder ab. */
export const registriereSpaetEmpfaenger = (projectId: string, fn: Empfaenger): (() => void) => {
    empfaenger.set(projectId, fn);
    return () => {
        // Eine spätere Anmeldung (Remount, StrictMode) bleibt stehen.
        if (empfaenger.get(projectId) === fn) empfaenger.delete(projectId);
    };
};

/** Gibt die Änderung an die eingehängte Instanz des Projekts; false = keine da. */
export const anEingehaengteInstanz = (projectId: string, aendern: SpaetAenderung): boolean => {
    const fn = empfaenger.get(projectId);
    if (!fn) return false;
    fn(aendern);
    return true;
};
